(function () {
  function initBookmarkTooltips() {
    // Dont do anything if the user isnt active
    if (!currentUser.subscriber || !window.Cookies) {
      return;
    }

    // Show the tooltip?
    var bookmarkCookie = window.Cookies.getJSON('bookmark-cookie'),
      initialbookmarkValues = {
        visitCount: 0,
        valid: true,
      },
      bookmarkVisitCount;

    if (!bookmarkCookie) {
      window.Cookies.set('bookmark-cookie', initialbookmarkValues, { expires: 60 });
      bookmarkCookie = initialbookmarkValues;
    }

    // Get the current visit count
    bookmarkVisitCount = bookmarkCookie.visitCount;
    // As long as the visit count is under X, show the tooltip
    if (bookmarkCookie.valid && bookmarkVisitCount <= 10) {
      window.Cookies.set(
        'bookmark-cookie',
        { visitCount: bookmarkVisitCount + 1, valid: true },
        { expires: 60 }
      );
    } else {
      window.Cookies.set('bookmark-cookie', { valid: false }, { expires: 60 });
    }
  }

  if (document.readyState !== 'loading') {
    initBookmarkTooltips();
  } else {
    document.addEventListener('DOMContentLoaded', initBookmarkTooltips);
  }
})();
